webpackJsonp([8172977268794],{

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Fellows = __webpack_require__(25);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _BioCard = __webpack_require__(127);
	
	var _BioCard2 = _interopRequireDefault(_BioCard);
	
	var _BioTray = __webpack_require__(114);
	
	var _BioTray2 = _interopRequireDefault(_BioTray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Speakers = function (_React$Component) {
	    _inherits(Speakers, _React$Component);
	
	    function Speakers(props) {
	        _classCallCheck(this, Speakers);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            teamTray: false,
	            activeProfile: null
	
	            // this.speakerStaff = this.sort(this.props.data.speakerProfiles.edges)
	        };_this.moderatorStaff = _this.sort(_this.props.data.moderatorProfiles.edges);
	        _this.academySpeakersActiveList = _this.sort(_this.props.data.allTimeSpeakerProfiles.edges);
	
	        return _this;
	    }
	
	    Speakers.prototype.sort = function sort(staff) {
	        // alphabetize by first name
	        if (staff.length > 0) {
	            return staff.sort(function (a, b) {
	                if (a.node.name < b.node.name) return -1;
	                if (a.node.name > b.node.name) return 1;
	                return 0;
	            });
	        }
	    };
	
	    Speakers.prototype.setActiveStaff = function setActiveStaff(profile, e) {
	        document.body.parentNode.classList.add('freeze');
	        this.setState({ teamTray: true, activeProfile: profile });
	    };
	
	    Speakers.prototype.unsetActiveStaff = function unsetActiveStaff() {
	        document.body.parentNode.classList.remove('freeze');
	        this.setState({ teamTray: false, activeProfile: null });
	    };
	
	    Speakers.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unsetActiveStaff();
	    };
	
	    Speakers.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props$data = this.props.data,
	            speakerProfiles = _props$data.speakerProfiles,
	            moderatorProfiles = _props$data.moderatorProfiles;
	
	
	        var temporarySEOData = {
	            keywords: null,
	            openGraphDescription: {
	                openGraphDescription: "Leadership in Action Speakers | Global Citizen Academy"
	            },
	            openGraphImage: null,
	            openGraphTitle: "Leadership in Action Speakers | Global Citizen Academy",
	            pageDescription: {
	                pageDescription: "Leadership in Action Speakers"
	            },
	            pageTitle: "Leadership in Action Speakers | Global Citizen Academy"
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'page-team page-speakers', style: { margin: '0 auto' } },
	            _react2.default.createElement(_CustomHelmet2.default, { data: temporarySEOData }),
	            _react2.default.createElement(_Hero2.default, { title: 'SPEAKER SERIES:<br/>LEADERSHIP IN ACTION' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'cards-super-wrap' },
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'capper impact-cards-wrapper' },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { className: 'impact-header', width: '12' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'text-center' },
	                            'The Academy speaker series puts today\'s most impactful leaders in conversation with Global Citizen Year students \u2014 the rising leaders of tomorrow. As these influential changemakers share their leadership journeys, students gain valuable insights on overcoming challenges, learning from mistakes, staying true to their values, and committing to continual growth.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'Unlike traditional lectures or TEDtalks, these deeply human conversations are live, unscripted and student-led, featuring alumni moderators and questions from Academy students.',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            'Here you\'ll find a complete list of past and present Academy speakers.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'impact-cards-wrapper capper no-top-padding' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2 text-center' },
	                        'Academy Speakers'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'capper impact-cards-wrapper no-top-padding' },
	                    this.academySpeakersActiveList.length > 0 && _react2.default.createElement(
	                        _Row2.default,
	                        { className: 'no-padding' },
	                        this.academySpeakersActiveList.map(function (staff, index) {
	                            return _react2.default.createElement(
	                                _Column2.default,
	                                { key: index, width: '3', tablet: '4', mobile: '6' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { onClick: function onClick() {
	                                            return _this2.setActiveStaff(staff.node);
	                                        } },
	                                    _react2.default.createElement(_BioCard2.default, { data: staff.node })
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'capper impact-cards-wrapper no-top-padding no-bottom-padding' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2 text-center' },
	                        'Alumni Moderators'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'capper impact-cards-wrapper no-top-padding' },
	                    this.moderatorStaff.length > 0 && _react2.default.createElement(
	                        _Row2.default,
	                        { className: 'no-padding' },
	                        this.moderatorStaff.map(function (staff, index) {
	                            return _react2.default.createElement(
	                                _Column2.default,
	                                { key: index, width: '3', tablet: '4', mobile: '6' },
	                                _react2.default.createElement(
	                                    'span',
	                                    { onClick: function onClick() {
	                                            return _this2.setActiveStaff(staff.node);
	                                        } },
	                                    _react2.default.createElement(_BioCard2.default, { data: staff.node })
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement('img', { className: 'green-brush-team', src: '/images/green-strokes.png', alt: 'green brush strokes' })
	            ),
	            _react2.default.createElement(_BioTray2.default, { teamTray: this.state.teamTray,
	                activeProfile: this.state.activeProfile,
	                setActiveFellow: function setActiveFellow() {
	                    return _this2.setActiveStaff();
	                },
	                unsetActiveFellow: function unsetActiveFellow() {
	                    return _this2.unsetActiveStaff();
	                },
	                noLink: true })
	        );
	    };
	
	    return Speakers;
	}(_react2.default.Component);
	
	exports.default = Speakers;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-academy-speakers-js-e2b16a1ca901a07b89ec.js